import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import axios from 'axios';

const API_URL = process.env.REACT_APP_API_URL;

export const fetchProjectTeamOptions = createAsyncThunk(
  'projectListOptions/fetchTeamOptions',
  async (_, { signal, rejectWithValue }) => {
    try {
      const res = await axios.get(`${API_URL}/api/teamOptions`, { signal });
      return Array.isArray(res.data) ? res.data : [];
    } catch (e) {
      if (e?.code === 'ERR_CANCELED' || e?.name === 'CanceledError') throw e;
      console.error('projectListOptions/fetchTeamOptions failed', e);
      return rejectWithValue(e?.message || 'Failed to fetch team options');
    }
  }
);

export const fetchProjectRunnerOptions = createAsyncThunk(
  'projectListOptions/fetchRunnerOptions',
  async (_, { signal, rejectWithValue }) => {
    try {
      const res = await axios.get(`${API_URL}/api/projects/runnerOptions`, {
        signal,
        params: { mode: 'Initials' },
      });
      return Array.isArray(res.data) ? res.data : [];
    } catch (e) {
      if (e?.code === 'ERR_CANCELED' || e?.name === 'CanceledError') throw e;
      console.error('projectListOptions/fetchRunnerOptions failed', e);
      return rejectWithValue(e?.message || 'Failed to fetch runner options');
    }
  }
);

export const fetchProjectTagOptions = createAsyncThunk(
  'projectListOptions/fetchTagOptions',
  async (_, { signal, rejectWithValue }) => {
    try {
      const res = await axios.get(`${API_URL}/api/projects/tagOptions`, { signal });
      return Array.isArray(res.data) ? res.data : [];
    } catch (e) {
      if (e?.code === 'ERR_CANCELED' || e?.name === 'CanceledError') throw e;
      console.error('projectListOptions/fetchTagOptions failed', e);
      return rejectWithValue(e?.message || 'Failed to fetch tag options');
    }
  }
);

export const fetchProjectStatusOptions = createAsyncThunk(
  'projectListOptions/fetchStatusOptions',
  async (_, { signal, rejectWithValue }) => {
    try {
      const res = await axios.get(`${API_URL}/api/projects/statusOptions`, { signal });
      return Array.isArray(res.data) ? res.data : [];
    } catch (e) {
      if (e?.code === 'ERR_CANCELED' || e?.name === 'CanceledError') throw e;
      console.error('projectListOptions/fetchStatusOptions failed', e);
      return rejectWithValue(e?.message || 'Failed to fetch status options');
    }
  }
);

export const fetchUserTeam = createAsyncThunk(
  'projectListOptions/fetchUserTeam',
  async ({ uid }, { signal, rejectWithValue }) => {
    try {
      const res = await axios.get(`${API_URL}/api/user/team`, {
        signal,
        headers: { 'Content-Type': 'application/json' },
        params: { UID: uid },
      });
      return res.data;
    } catch (e) {
      if (e?.code === 'ERR_CANCELED' || e?.name === 'CanceledError') throw e;
      console.error('projectListOptions/fetchUserTeam failed', e);
      return rejectWithValue(e?.message || 'Failed to fetch user team');
    }
  }
);

const slice = createSlice({
  name: 'projectListOptions',
  initialState: { error: null },
  reducers: {},
  extraReducers: (builder) => {
    builder.addMatcher(
      (action) => action.type.startsWith('projectListOptions/') && action.type.endsWith('/rejected'),
      (state, action) => {
        if (action?.meta?.aborted) return;
        state.error = action.payload || action.error?.message || null;
      }
    );
  },
});

export default slice.reducer;


